export default "__VITE_ASSET__DgIZfb0e__"